module.exports = __webpack_public_path__ + "static/media/search-icon.4cd9bab3.svg";